import { render, staticRenderFns } from "./LatestReviews.vue?vue&type=template&id=165b5e4e&"
import script from "./LatestReviews.vue?vue&type=script&lang=js&"
export * from "./LatestReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports